import "./widgetLg.css";
import { useGetAllOrderQuery } from '../../../services/orderApi';
import { useCurrency } from "../../currency/currencyContext"; // Add currency context

export default function WidgetLg() {
  const { data, isSuccess } = useGetAllOrderQuery();
  const { formatPrice, getCurrencySymbol, convertPrice, getCurrentCurrency } = useCurrency(); // Add currency context
  let arr = [];

  if (!isSuccess) return <div>Loading.....</div>;

  if (isSuccess) {
    arr = data.slice(-5);
  }

  const Button = ({ type }) => {
    let type1 = "";
    if (type === 'On The way to deliver') type1 = 'way';
    else if (type === 'Order Placed') type1 = 'Placed';
    else if (type === 'Under Package') type1 = 'Package';
    else if (type === 'Deliverd') type1 = 'Deliverd';
    else if (type === 'Canceled') type1 = 'Canceled';

    return <button className={"widgetLgButton " + type1}>{type}</button>;
  };

  return (
    <div className="widgetLg">
      <h3 className="widgetLgTitle">Latest Orders</h3>
      <div className="widgetLgTableContainer">
        <table className="widgetLgTable">
          <thead>
            <tr className="widgetLgTr">
              <th className="widgetLgThs">Order ID</th>
              <th className="widgetLgThs">Date</th>
              <th className="widgetLgThs">Amount</th>
              <th className="widgetLgThs">Status</th>
            </tr>
          </thead>
          <tbody>
            {arr.map((data, index) => (
              <tr key={index} className="widgetLgTr">
                <td className="widgetLgUser">
                  <span className="widgetLgDate">{data.order_Tracking_Id}</span>
                </td>
                <td className="widgetLgDate">{data.order_Placment_Date}</td>
                <td className="widgetLgAmount">{formatPrice(data.total_Amount)}</td>
                <td className="widgetLgStatus">
                  <Button type={data.order_Status} />
                </td>
              </tr>
            ))}
          </tbody>  
        </table>
      </div>
    </div>
  );
}